import { Config } from '../../config';
import { Translations } from '../../i18n/i18n';
import { ApiOrder, ApiSubscriptionOrder } from '../../types';
import { addHours } from '../subscriptions/utils';

export const hasTimeLeft = (timeLeft: number, subscriptionOrder: ApiSubscriptionOrder) => {
	if (!!subscriptionOrder) {
		if (timeLeft > 0) {
			return true;
		}
		return false;
	}
	return true;
};

export const getSecondsLeftToEdit = (order: ApiOrder): number => {
	const dateNow = new Date();

	if (!order.subscriptionOrder) {
		const createOrderEvent = order.events.find((event) => event.status === 1);
		if (!createOrderEvent) return -1;

		const datePurchased = new Date(createOrderEvent.dateCreated);
		const sendOrderDate: Date = addHours(new Date(datePurchased), 72);
		const seconds = Math.floor((sendOrderDate.getTime() - dateNow.getTime()) / 1000);

		return seconds;
	}
	const dateCreated = order.subscriptionOrder.dateCreated;
	const shipInHours = order.subscriptionOrder.shipInHours;
	const sendOrderDate: Date = addHours(new Date(dateCreated), shipInHours);
	const seconds = Math.floor((sendOrderDate.getTime() - dateNow.getTime()) / 1000);

	return seconds;
};

export const getTimeLeftString = (order: ApiOrder, t: Translations['orderPages'], locale: Config['locale']): string => {
	let seconds = getSecondsLeftToEdit(order);
	if (seconds < 0) {
		return '';
	}

	var minutes = Math.floor(seconds / 60);
	var hours = Math.floor(minutes / 60);
	var days = Math.floor(hours / 24);

	hours = hours - days * 24;
	minutes = minutes - days * 24 * 60 - hours * 60;
	seconds = seconds - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60;

	const valuesObject = { days, hours, minutes, seconds };
	let timesArray = [];

	for (const key in valuesObject) {
		if (valuesObject[key as keyof typeof valuesObject]) {
			const updatedKey = valuesObject[key as keyof typeof valuesObject] === 1 ? key.slice(0, -1) : key;

			timesArray.push(
				valuesObject[key as keyof typeof valuesObject] +
					' ' +
					t.timeStrings[updatedKey as keyof typeof t.timeStrings]
			);
		}
	}

	const timeString = new Intl.ListFormat(locale, { style: 'long', type: 'conjunction' }).format(timesArray);

	return timeString;
};
